import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as StarIconPointy } from '@pkg/assets/icons/v2/star-outline.svg';
import { useHandleWishlist } from '@pkg/components/Wishlist/hooks';
import { useAppDispatch } from '@pkg/hooks';
import { type SupportedChain } from '@pkg/types';
import { capitalizeFirstLetter } from '@pkg/utils';

import { wishlistActions } from '@app/store/slices';

import { Count, Icon, Wrapper } from './styles';

interface WishlistButtonProps {
    contract?: string;
    token_id?: string;
    collection_slug?: string;
    chain?: SupportedChain;
}

export const WishlistButton = ({ contract, token_id, collection_slug, chain }: WishlistButtonProps) => {
    const { t: translate } = useTranslation(['nft_details']);
    const dispatch = useAppDispatch();

    const { handleRemoveFromWishlist, handleAddFlow, isLoading, isAddedItem, wishlistedCount } = useHandleWishlist({
        contract,
        tokenId: token_id,
        collectionSlug: collection_slug,
        chain: capitalizeFirstLetter(chain),
    });

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        event.stopPropagation();

        if (isLoading) return;

        if (isAddedItem) {
            handleRemoveFromWishlist();
        } else {
            handleAddFlow();

            dispatch(
                wishlistActions.setWishListModalData({
                    contract_address: contract,
                    token_id: token_id,
                    slug: collection_slug,
                }),
            );
        }
    };

    return (
        <Wrapper
            $isLoading={isLoading}
            $isAdded={isAddedItem}
            onClick={handleClick}
            title={
                isAddedItem ? translate('detail_view_remove_from_wishlist') : translate('detail_view_add_to_wishlist')
            }
        >
            <Icon>
                <StarIconPointy />
            </Icon>
            {wishlistedCount && <Count>{wishlistedCount}</Count>}
        </Wrapper>
    );
};
